import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";


@Component({
  selector: 'modal-content',
  templateUrl: 'confirm-modal.component.html'
})
export class ConfirmModalComponent {

  public onClose: Subject<boolean>;

  constructor(public bsModalRef: BsModalRef) {

  }

  ngOnInit() {
    this.onClose = new Subject();
  }

  resetE101() {

    this.onClose.next(true);
    this.bsModalRef.hide();

  }

}
